import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepository } from '../../../../shared/infrastructure/api.repository';
import { Client } from '../../domain/entities/client.entity';
import {
  ClientRepositoryPort,
  ClientListAllRequest,
  ClientListPagedRequest,
  ClientListPagedResponse,
} from '../../domain/repositories/client.repository.port';
import { ClientMapper, ClientApiResponse, ClientListPagedApiResponse } from '../mappers/client.mapper';

@Injectable({ providedIn: 'root' })
export class ClientRepository extends ApiRepository implements ClientRepositoryPort {
  private readonly baseUrl = '/clients';

  create(name: string, nationalIdentityCard: string): Observable<string> {
    return this.post<string, { name: string; nationalIdentityCard: string }>(
      `${this.baseUrl}/Create`,
      { name, nationalIdentityCard }
    );
  }

  remove(id: string): Observable<void> {
    return this.delete(`${this.baseUrl}/Delete/${id}`);
  }

  edit(id: string, name: string, nationalIdentityCard: string): Observable<void> {
    return this.put<void, { name: string; nationalIdentityCard: string }>(
      `${this.baseUrl}/Edit/${id}`,
      { name, nationalIdentityCard }
    );
  }

  getDetails(id: string): Observable<Client> {
    return this.get<ClientApiResponse>(`${this.baseUrl}/GetDetails/${id}`).pipe(
      map((response) => ClientMapper.toDomain(response))
    );
  }

  getListAll(request: ClientListAllRequest): Observable<Client[]> {
    return this.post<{ items: ClientApiResponse[] }, ClientListAllRequest>(
      `${this.baseUrl}/GetListAll`,
      request
    ).pipe(map((response) => ClientMapper.toDomainList(response.items)));
  }

  getListPaged(request: ClientListPagedRequest): Observable<ClientListPagedResponse> {
    return this.post<ClientListPagedApiResponse, ClientListPagedRequest>(
      `${this.baseUrl}/GetListPaged`,
      request
    ).pipe(
      map((response) => ({
        items: ClientMapper.toDomainList(response.items),
        pageNumber: response.pageNumber,
        pageSize: response.pageSize,
        totalPages: response.totalPages,
        totalItemsCount: response.totalItemsCount,
        orderField: response.orderField,
        ascendingOrder: response.ascendingOrder,
      }))
    );
  }
}
